import React from 'react';
import { reduxForm, Field } from 'redux-form';
import cn from 'classnames';

import InputField from 'components/InputField';
import SelectField from 'components/SelectField';
import FormError from 'components/FormError';
import { isEmail } from 'helpers/validators';

import styles from './styles.module.scss';

const carriersOptions = [
  ['any', 'Any'],
  ['att', 'AT&T'],
  ['simo', 'Simo'],
  ['quick', 'Quick'],
];

const statusesOptions = [
  ['any', 'Any'],
  ['new', 'New'],
  ['active', 'Active'],
  ['suspended', 'Suspended'],
  ['expired', 'Expired'],
];

const UserSubsToCsvForm = ({ handleSubmit, error }) => (
  <form onSubmit={handleSubmit}>
    <p>Please enter email to send subscriptions csv report</p>
    <div className={styles.inputs}>
      <div className={cn(styles.input, styles.fullInput)}>
        <Field component={InputField} name="email" label="Email*" />
      </div>
    </div>
    <p>
      <b>Optional filters:</b>
    </p>
    <div className={styles.inputs}>
      <div className={styles.input}>
        <Field
          component={SelectField}
          name="carriers"
          label="Carrier"
          options={carriersOptions}
          multiple
        />
      </div>
      <div className={styles.input}>
        <Field
          component={SelectField}
          name="statuses"
          label="Status"
          options={statusesOptions}
          multiple
        />
      </div>
    </div>
    {error && <FormError error={error} />}
    <br />
    <button className="btn btn-primary">Confirm</button>
  </form>
);

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = 'Required';
  } else if (!isEmail(values.email)) {
    errors.email = 'Invalid email';
  }

  if (values?.carriers?.length > 1 && values.carriers.includes('any')) {
    errors.carriers = 'Invalid combination';
  }

  if (values?.statuses?.length > 1 && values.statuses.includes('any')) {
    errors.statuses = 'Invalid combination';
  }

  return errors;
};

export default reduxForm({
  form: 'userSubsToCsvForm',
  validate,
  enableReinitialize: true,
})(UserSubsToCsvForm);
